import React, {useState, useEffect} from 'react';
import {Route, Switch,useHistory} from 'react-router-dom';


import {connect} from 'react-redux';
//import {Gatekeeper} from 'gatekeeper-client-sdk';
import Apicall from '../../rest/Apicall';


import Dashboard from '../../pages/Dashboard';
import BasicData from '../../pages/company/BasicData';
import Code from '../../pages/code/Code';
import User from '../../pages/user/User';
import Partners from '../../pages/partner/Partners';
import Article from '../../pages/article/Article';
import Warehouse from '../../pages/warehouse/Warehouse';
import Attendance from '../../pages/attendance/Attendance';
import Document from '../../pages/document/Document';
import DocumentWorkOrder from '../../pages/document/DocumentWorkOrder';
import DocumentOperationsProcessing from '../../pages/document/DocumentOperationsProcessing';

import Bom from '../../pages/bom/Bom';
import DocumentWrRouteTemplate from '../../pages/document/DocumentWrRouteTemplate';
import DocumentWarehouse from '../../pages/document/DocumentWarehouse';
//import Profile from '../../pages/profile/Profile';

import Header from './header/Header';
import Footer from './footer/Footer';
import MenuSidebar from './menu-sidebar/MenuSidebar';
import PageLoading from '../../components/page-loading/PageLoading';
import * as ActionTypes from '../../store/actions';



const Main = ({onUserLoad,onCompanyLoad,onUserLogout}) => {  //,
    const [appLoadingState, updateAppLoading] = useState(false);
    const [menusidebarState, updateMenusidebarState] = useState({
        isMenuSidebarCollapsed: false
    });

    const toggleMenuSidebar = () => {
        updateMenusidebarState({
            isMenuSidebarCollapsed: !menusidebarState.isMenuSidebarCollapsed
        });
    };

    const history = useHistory();


    const redirectToLogin = () => {
        onUserLogout();
        history.push('/login');
    }

    useEffect(() => {
        updateAppLoading(true);
        const fetchProfile = async () => {
            try {
                const response = await Apicall.getProfile();
                onUserLoad({...response});
                updateAppLoading(false);
                if(response===''){
                    redirectToLogin();
                }
            } catch (error) {
               // redirectToLogin();
                
            }
        };
        updateAppLoading(true);
        const fetchCompanyProfile = async () => {
            try {
                const response = await Apicall.getCompanyProfile();
                onCompanyLoad({...response});
                updateAppLoading(false);
            } catch (error) {
              
                updateAppLoading(false);
            }
        };
        fetchProfile();
        fetchCompanyProfile();
        
        return () => {};
    }, [onUserLoad,onCompanyLoad]);

    document.getElementById('root').classList.remove('register-page');
    document.getElementById('root').classList.remove('login-page');
    document.getElementById('root').classList.remove('hold-transition');

    document.getElementById('root').className += ' sidebar-mini';

    if (menusidebarState.isMenuSidebarCollapsed) {
        document.getElementById('root').classList.add('sidebar-collapse');
        document.getElementById('root').classList.remove('sidebar-open');
    } else {
        document.getElementById('root').classList.add('sidebar-open');
        document.getElementById('root').classList.remove('sidebar-collapse');
    }

    let template;

    if (appLoadingState) {
        template = <PageLoading />;
    } else {
        template = (
            <>
                <Header toggleMenuSidebar={toggleMenuSidebar} />

                <MenuSidebar />

                <div className="content-wrapper">
                    <div className="pt-3" />
                    <section className="content">
                        <Switch>                            
                            <Route exact path="/" component={Dashboard} />                        
                            <Route exact path="/basicData" component={BasicData} />                        
                            <Route exact path="/code" component={Code} />       
                            <Route exact path="/user" component={User} />                            
                            <Route exact path="/partner" component={Partners} />  
                            <Route exact path="/attendance" component={Attendance} />                            
                            <Route exact path="/customers" component={(props) => (<Partners partnerType="customer" {...props} />)} />
                            <Route exact path="/suppliers" component={(props) => (<Partners partnerType="supplier" {...props} />)} />
                            <Route exact  path="/anotherPartners" component={(props) => (<Partners partnerType="another" {...props} />)} />
                            <Route exact  path="/article" component={Article} />                            
                            <Route exact  path="/operationsProcessing" component={DocumentOperationsProcessing} />
                            <Route exact  path="/workOrder" component={DocumentWorkOrder} />
                            <Route exact  path="/wrRouteTemplate" component={DocumentWrRouteTemplate} />
                            <Route exact  path="/bom" component={Bom} />
                            <Route exact  path="/warehouse" component={Warehouse} />
                            <Route exact path="/warehouseOperations" component={(props) => (<DocumentWarehouse {...props} />)} />
                            <Route exact path="/orders" component={(props) => (<Document entitySubName="order" {...props} />)} />
                            <Route exact path="/invoices" component={(props) => (<Document entitySubName="invoice" {...props} />)} />
                            <Route exact  path="/deliveryNotes" component={(props) => (<Document entitySubName="deliveryNote" {...props} />)} />

                           
                        </Switch>
                    </section>
                </div>
                <Footer />
                <div
                    id="sidebar-overlay"
                    role="presentation"
                    onClick={toggleMenuSidebar}
                    onKeyDown={() => {}}
                />
            </>
        );
    }

    return <div className="wrapper">{template}</div>;
};

const mapStateToProps = (state) => ({
    user: state.auth.currentUser,
    company: state.company.currentCompany
});

const mapDispatchToProps = (dispatch) => ({
    onUserLoad: (user) =>
        dispatch({type: ActionTypes.LOAD_USER, currentUser: user}),
    onCompanyLoad: (company) =>
        dispatch({type: ActionTypes.LOAD_COMPANY, currentCompany: company}),
    onUserLogout: () => 
        dispatch({type: ActionTypes.LOGOUT_USER})    
});



export default connect(mapStateToProps, mapDispatchToProps)(Main);
